import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { Flex } from "@chakra-ui/react";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { Button, TextButton } from "@/components/essentials/button";
import { RecoveryCodeForm } from "@/components/fragments/forms/recovery-code-form";
import { changeMfaCodeScreenTestId, descriptionTestId, submitButtonTestId, titleTestId } from "./const";
import { type RecoveryFormValues } from "./type";
import { toysubMfaQAUrl } from "@/configs/externalUrls";
import Link from "next/link";

interface RecoveryFormsProps {
  readonly isLoading: boolean;
  readonly onChangeMfaCodeScreen: () => void;
}

export const RecoveryForms: FC<RecoveryFormsProps> = ({ isLoading, onChangeMfaCodeScreen }) => {
  const {
    formState: { isValid },
  } = useFormContext<RecoveryFormValues>();

  return (
    <Flex flexDir="column" gridGap="1.5rem" alignItems="flex-start">
      <Box>
        <Typography variant="display3" data-testid={titleTestId}>
          二段階認証がオンになっています
        </Typography>
        <Typography variant="text4" color="gray.dark" data-testid={descriptionTestId}>
          <p>認証アプリに表示されている認証コードを入力してください</p>
          <p>
            スマ―トフォンの機種変更・紛失等で認証コードを取得できない場合は、リカバリーコードをご利用下さい。各リカバリーコードは一度しか利用できません。
          </p>
        </Typography>
      </Box>
      <RecoveryCodeForm />
      <TextButton
        onClick={onChangeMfaCodeScreen}
        as="a"
        color="mono.dark.54"
        size="sm"
        alignSelf="flex-end"
        data-testid={changeMfaCodeScreenTestId}
      >
        二段階認証コードを使う
      </TextButton>
      <Box w="100%" my="2rem" textAlign="center">
        <Button
          isLoading={isLoading}
          type="submit"
          size="lg"
          w="100%"
          styleVariant="secondary"
          disabled={!isValid || isLoading}
          data-testid={submitButtonTestId}
        >
          認証する
        </Button>
      </Box>
      <Link href={toysubMfaQAUrl} passHref>
        <TextButton as="a" color="gray.dark" alignSelf="flex-end" target="_blank" rel="noopener norefferer">
          二段階認証が通らない場合
        </TextButton>
      </Link>
    </Flex>
  );
};
